import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { Grid } from '@mui/material';

import { getListAPI as getExplevelList } from 'components/explevel/ExplevelAPI';
import { setExplevelList, setExplevelDashboardExplevelList } from 'store/slice/ManufSlice';
import ExplevelDashboard from '../ExplevelDashboard';

import { openDrawer } from './../../../store/slice/MenuSlice';

export default function ExplevelPageImpl() {
    const dispatch = useDispatch();
    const { explevelList} = useSelector((state)=>state.manufslice);
    
    const getExplevelListSuccess = (list) =>{dispatch(setExplevelList(list));}
    useEffect(() => {
        getExplevelList(()=>{}, getExplevelListSuccess);
    },[]);
    useEffect(()=>{
        dispatch(setExplevelDashboardExplevelList( explevelList));
    },[ explevelList])

    return (
        < ExplevelDashboard />
    )

}